import { all, fork, spawn } from "redux-saga/effects";
import authSaga from "./auth";
import webSaga from "./dashboard";

export default function* rootSaga() {
  yield all([spawn(authSaga), spawn(webSaga)]);
}
